export class RequestStats {
  aborted = false
  loadTime = 0
  totalTime = 0
}

export function getRangeValue (value) {
  if (!value || value[0] == null || (value[0] === 0 && value[1] == null)) {
    return
  }
  let ret = 'bytes=' + value[0] + '-'
  if (value[1]) ret += value[1]
  return ret
}
